import { api, config } from "@/assets/js/util.js";

export default {
  install: (app, options) => {
    app.mixin({
      components: {},
      data() {
        return {
          is_filter: true,
        };
      },
      methods: {
        onClose() {
          this.closeActiveTab();
        },
        closeActiveTab() {
          let that = this;
          let tab = that.tabList.find(function (item) {
            return item.id == that.activeTab[0];
          });

          if (tab !== undefined) {
            this.tabList.forEach((element, index) => {
              if (element.id === tab.id) {
                this.tabList.splice(index, 1);
              }
            });

            if (tab.id == this.activeTab[0]) {
              let last = this.tabList.slice(-1)[0];

              if (last !== undefined) {
                this.$router.push(last.url);
                this.activeTab.pop();
                this.activeTab.push(last.id);
              }
            }
          }
        },
        dateFormat(date) {
          if (!date) {
            return "";
          }
          if (date.length > 0) {
            return (
              date.substr(0, 4) +
              "-" +
              date.substr(4, 2) +
              "-" +
              date.substr(-2)
            );
          }
        },
        dateFormat2(d) {
          let date = new Date(d);
          let month = date.getMonth() + 1;

          if (month < 10) {
            month = "0" + month;
          }
          return date.getFullYear() + "-" + month + "-" + date.getDate();
        },
        getLocation(row, col) {
          let colmap = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "AA",
            "AB",
            "AC",
            "AD",
            "AE",
            "AF",
            "AG",
            "AH",
            "AI",
            "AJ",
            "AK",
            "AL",
            "AM",
            "AN",
            "AO",
            "AP",
            "AQ",
            "AR",
          ];
          return colmap.slice(col, col + 1) + row;
        },
        onExportExcel(table_id, img_list) {
          let that = this;
          const wb = new ExcelJS.Workbook();
          const ws = wb.addWorksheet("blort");

          var table = document.getElementById(table_id);

          let offset = [];

          Array.from(table.rows).forEach(function (rows, row) {
            let colfix = 0;
            Array.from(rows.cells).forEach(function (cell, col) {
              if (cell.getElementsByTagName("img").length > 0) {
                let img = cell.getElementsByTagName("img")[0];
                let prodcd = img.getAttribute("data-src");

                let obj = img_list.find(function (item) {
                  return item.prodcd == prodcd;
                });
                console.log(obj, "prodcd");
                if (obj) {
                  const myBase64Image = obj.value;

                  const imageId2 = wb.addImage({
                    base64: myBase64Image,
                    extension: "png",
                  });

                  ws.addImage(imageId2, {
                    tl: { col: col + colfix, row: row },
                    ext: { width: 120, height: 120 },
                  });
                  const rowins = ws.getRow(row + 1);
                  rowins.height = 130;

                  const column = ws.getColumn(col + colfix + 1);
                  column.width = 15;
                }
              }

              let location = that.getLocation(row + 1, col + colfix);
              offset.forEach(function (item) {
                if (item === location) {
                  colfix++;
                  location = that.getLocation(row + 1, col + colfix);
                }
              });

              //   console.log(location);
              //   console.log(offset);

              ws.getCell(location).value = cell.outerText;

              for (
                let offset_col = 1;
                offset_col <= cell.colSpan;
                offset_col++
              ) {
                for (
                  let offset_row = 1;
                  offset_row <= cell.rowSpan;
                  offset_row++
                ) {
                  //   console.log(
                  //     that.getLocation(row + offset_row, col + offset_col)
                  //   );

                  offset.push(
                    that.getLocation(
                      row + offset_row,
                      col + offset_col - 1 + colfix
                    )
                  );
                }
              }

              if (cell.colSpan > 1 || cell.rowSpan > 1) {
                let rowSpan = cell.rowSpan - 1;
                let colSpan = cell.colSpan - 1;

                let end = that.getLocation(
                  row + rowSpan + 1,
                  col + colSpan + colfix
                );
                console.log(location + ":" + end);
                ws.mergeCells(location + ":" + end);
              }

              //   if (cell.colSpan > 1 || cell.rowSpan > 1) {
              //     let start = that.getLocation(row + 1, col + colSpan);

              //     rowSpan += cell.rowSpan - 1;
              //     colSpan = cell.colSpan - 1;

              //     let end = that.getLocation(row + rowSpan, col + colSpan);
              //     console.log(start + ":" + end);
              //     ws.mergeCells(start + ":" + end);
              //   }
            });
          });

          const buffer = wb.xlsx.writeBuffer();
          buffer.then(function (e) {
            let ab = Buffer.from(e, "binary");
            const link = document.createElement("a");
            const body = document.querySelector("body");

            const blob = new Blob([ab], {
              type: "application/vnd.ms-excel",
            });

            link.href = window.URL.createObjectURL(blob); // 创建对象url
            link.download = "导出.xlsx";
            link.style.display = "none";
            body.appendChild(link);
            link.click();
            body.removeChild(link);
          });
        },
        milliFormat(num, length) {
          if (isNaN(num)) {
            return "";
          }
          num = parseFloat(num);
          if (isNaN(num)) {
            return "";
          }
          if (length !== undefined) {
            num = Math.round(num * Math.pow(10, length)) / Math.pow(10, length);
          } else {
            num = Math.round(num);
          }

          var reg = /\d(?=(?:\d{3})+\b)/g;
          return (num + "").replace(reg, "$&,");
        },
        getYearStartDate() {
          let date = new Date();
          return `${date.getFullYear()}-01-01`;
        },
        getMonthStartDate() {
          let date = new Date();
          return `${date.getFullYear()}-${date.getMonth() + 1}-01`;
        },
        getTodayDate() {
          let date = new Date();
          return `${date.getFullYear()}-${date.getMonth() +
            1}-${date.getDate()}`;
        },
        getYear() {
          let date = new Date();
          return `${date.getFullYear()}`;
        },
        fixedTable(table_id) {
          let scrollbarEl = this.$refs[table_id].wrap;

          scrollbarEl.onscroll = () => {
            var thead = document.querySelectorAll(
              "#" + table_id + " thead th:not(.xx)"
            );

            thead.forEach(function (item) {
              item.style.transform =
                "translate3d(0," + scrollbarEl.scrollTop + "px, 0)";
            });

            var tbody = document.querySelectorAll("#" + table_id + " tbody th");

            tbody.forEach(function (item) {
              item.style.transform =
                "translate3d(" + scrollbarEl.scrollLeft + "px, 0,0)";
            });

            var xx = document.querySelectorAll("#" + table_id + " .xx");
            let height = xx[0].clientHeight;

            var node = document.createElement("div");
            node.className = "xy";
            node.style.top = height + 1 + "px";
            scrollbarEl.appendChild(node);

            xx.forEach(function (item) {
              item.style.transform =
                "translate3d(" +
                scrollbarEl.scrollLeft +
                "px," +
                scrollbarEl.scrollTop +
                "px, 0)";
            });
          };
        },
        toggleFilter() {
          if (this.is_filter) {
            this.is_filter = false;
          } else {
            this.is_filter = true;
          }
        },
        onExportExcel(table_id) {
          var elt = document.getElementById(table_id);
          var wb = XLSX.utils.table_to_book(elt, {
            sheet: "Sheet JS",
          });
          return XLSX.writeFile(wb, "导出.xlsx");
        },
        openSelectCustomer() {
          if (!this.form.BIZCD === true) {
            this.is_show_select_customer = true;
          }
        },
        saveSelectCustomer(node) {
          this.form.customer_id = node.id;
          this.form.customer_name = node.name;
          this.is_show_select_customer = false;
        },
        closeSelectCustomer() {
          this.is_show_select_customer = false;
        },
        clearCustomer() {
          let that = this;
          setTimeout(function () {
            that.form.BIZCD = "";
            return false;
          }, 200);
        },
        openSelectEmp() {
          if (!this.form.emp_id === true) {
            config.set("emp_param", { company: "CQG" });
            this.is_show_select_emp = true;
          }
        },
        saveSelectEmp(node) {
          this.form.emp_id = node.id;
          this.form.emp_name = node.name;
          this.is_show_select_emp = false;
        },
        closeSelectEmp() {
          this.is_show_select_emp = false;
        },
        clearSelectEmp() {
          let that = this;
          setTimeout(function () {
            that.form.emp_id = "";
            return false;
          }, 200);
        },
        setPageMeta() {
          // 获取页面数据
          const { title, keywords, description } = this.metaInfo;

          // 使用JavaScript操作文档头部的meta标签
          console.log(document.querySelector('meta[name="keywords"]'));
          const titleTag = document.querySelector('title');
          const meta = document.createElement('meta');
          meta.setAttribute('name', 'keywords');
          document.head.appendChild(meta);

          if (document.querySelector('meta[name="keywords"]') === null) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', 'keywords');
            document.head.appendChild(meta);
          }
          const keywordsTag = document.querySelector('meta[name="keywords"]');

          if (document.querySelector('meta[name="description"]') === null) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', 'description');
            document.head.appendChild(meta);
          }
          const descriptionTag = document.querySelector('meta[name="description"]');

          // 设置标题
          if (titleTag) {
            titleTag.innerText = title;
          }

          // 设置关键词
          if (keywordsTag) {
            keywordsTag.setAttribute('content', keywords);
          }

          // 设置描述
          if (descriptionTag) {
            descriptionTag.setAttribute('content', description);
          }
        }
      },
    });
  },
};
